import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GeneralService } from '../services/general.service';

export const AuthGuard: CanActivateFn = () => {
    const general_service = inject(GeneralService);
    const router = inject(Router);

    if (general_service.getToken) {
        return true;
    }

    return router.createUrlTree(['/auth/login']);
};